<script>
  import { onMount, tick } from "svelte";
  import { translate } from "../../../i18n/i18next.js";

  export let dialog
  export let onClose

  function onClickDialog(event) {
    if (event.target === dialog) {
      onClose()
    }
  }

  /**
   * This value should match that of MenuBar
   */
  let topControlsGap = "36px"

  onMount(async () => {
    await tick()
    dialog.showModal()
  })
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<dialog bind:this={dialog} on:click={onClickDialog}>
  <div class="inner">
    <div class="top-controls" style="--gap: {topControlsGap}">
      <button class="hamburger-button" on:click={onClose}>☰</button>
      <span class="title">{translate("generic.menu")}</span>
    </div>
    <div class="contents">
      <slot/>
    </div>
  </div>
</dialog>

<style>
  button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    outline: none;
    padding: 0;
    appearance: none;
  }

  dialog {
    overflow: visible;
    top: 50px;
    max-width: none;
    width: auto;
    height: calc(100vh - 50px);
    padding: 0;
    margin: 0;
    border: none;
    background: none;
  }

  .inner {
    --inner-left-gap: 10px;
    --inner-border-width: 1px;
    position: relative;
    left: var(--inner-left-gap);
    top: calc(-1 * var(--inner-border-width));
    max-height: 100%;
    width: fit-content;
    min-width: 250px;
    display: flex;
    flex-direction: column;
    background-color: white;
    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.2);
    border: var(--inner-border-width) solid #184398;
    border-radius: 5px;
  }

  .top-controls {
    height: 50px;
    padding: 8px calc(var(--gap) - var(--inner-left-gap));
    display: flex;
    gap: 10px;
  }

  .hamburger-button {
    font-weight: bold;
    font-size: 30px;
    color: darkgray;
    user-select: none;
  }

  .title {
    flex-grow: 1;
    flex-shrink: 1;
    font-weight: bold;
    font-size: 1.5rem;
    color: darkgray;
  }

  .contents {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
</style>
